import script from "./FooterBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"

import "./FooterBlindenzorglichtliefde.vue?vue&type=style&index=0&id=26308698&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26308698"]])

export default __exports__